import React from 'react';
import AccountContent from './AccountContent';

const ContentPicker = ({ lineItemResource, ...rest }) => {
  return (
    <AccountContent
      lineItemResource={lineItemResource}
      {...rest}
    />
  );
};

export default ContentPicker;
